<template src="./titlePage.html"></template>

<script>
export default {
    name: 'title-page',
    props: ['currentSelectedTab'],
    data() {
        return {
        }
    },
    computed: {
       titlePageData() {
            return this.$store.state.SessionsModule.Session;
       },
    },
    methods: {
        getRowsForSection(data) {
            let rows = [];
            
            for (let i = 0; i < data.length; i += 2) {
                let row = [];
    
                row.push(data[i]);
                
                if (i + 1 < data.length) {
                    row.push(data[i + 1]);
                } else {
                    row.push({}); 
                }
                
                rows.push(row);
            }
                
            return rows;
        },
    }
}
</script>